import React, {useState} from "react";
import {SlidesHomeService, BlocksHomeService} from "../services/GeneralServices";

export const HomeContext = React.createContext();

export default function HomeProvider({children}) {
   const [homeSlides, setHomeSlides] = useState({isLoading: true, data: []});
   const [homeBlocks, setHomeBlocks] = useState({isLoading: true, data: []});

   const getSlides = () => {
      if (homeSlides.data.length > 0) return false;
      SlidesHomeService()
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            setHomeSlides({isLoading: false, data: [...data]});
         })
         .catch((e) => {
            setHomeSlides({isLoading: true, data: []});
            console.log(e);
         });
   };

   const getBlocks = () => {
      if (homeBlocks.data.length > 0) return false;
      BlocksHomeService()
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            setHomeBlocks({isLoading: false, data: [...data]});
         })
         .catch((e) => {
            setHomeBlocks({isLoading: true, data: []});
            console.log(e);
         });
   };

   return <HomeContext.Provider value={{getSlides, homeSlides, getBlocks, homeBlocks}}>{children}</HomeContext.Provider>;
}
